import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call } from 'redux-saga/effects';
import { scheduleById } from 'redux/saga/entities/bound';
import { CLASS_DETAIL_ROUTE } from './ClassDetail.route.path';

export function* scheduleShorthandOnEnterSaga(client, nextState, replaceState) {
  const schedule = yield call(fetchEntityIfNeeded, scheduleById, [client, nextState.params.scheduleId]);
  if (schedule) {
    yield call(replaceState, {
      pathname: `${CLASS_DETAIL_ROUTE}/${schedule.venue.alias}/${schedule.class.alias}/${schedule.id}`,
      state: { status: 301 },
    });
  }
}
